import { isPendingAnswerableStagedAction } from '@renderer/chat/integrations/answerable'
import type { StagedAction } from '../../hooks/use-staged-actions'
import { actionViewBottomFadeTint, pendingAnswerableGlowTint } from '../action-view/action-view-state'
import { useActionViewModel } from '../action-view/use-action-view-model'

/**
 * The output view's bottom glow. A pending question or feedback card hoisted
 * into the floating bar wins; otherwise a lone draft wears its own Action View
 * glow (ready / unsent edits / updating). A batch of drafts has no single state
 * to show, so it gets the neutral fade.
 */
export function useChatOutputGlowTint(
  stagedActions: ReadonlyArray<StagedAction>,
  stagedActionIds: ReadonlyArray<string>,
): string | undefined {
  const pendingAnswerable = stagedActions.find(isPendingAnswerableStagedAction)
  const soloActionId = !pendingAnswerable && stagedActionIds.length === 1 ? stagedActionIds[0] : undefined
  const solo = useActionViewModel(soloActionId)
  if (pendingAnswerable) {
    return pendingAnswerableGlowTint(pendingAnswerable)
  }
  return solo.action ? actionViewBottomFadeTint(solo) : undefined
}
